<template>
    <div>
        <div class="flex">
            <label v-if="label" class="label">
                {{ label }}
                <BaseRequiredStar v-if="$attrs.required" />
            </label>
            <slot name="help"></slot>
        </div>
        <textarea
            v-bind="$attrs"
            :value="modelValue"
            :rows="rows"
            @input="$emit('update:modelValue', $event.target.value)"
        >
        </textarea>
        <slot name="tip"></slot>
    </div>
</template>

<script>

export default {
    props: {
        label: {
            type: String,
            default: ''
        },  
        modelValue: {
            type: [String, Number],
            default: ''
        },
        rows: [String, Number]
    }
}
</script>